/**
 * Action names
 */
const EVENT_VISIT_APP = 'visit_app';
const EVENT_SIGNUP = 'sign_up';
const EVENT_SEE_UPGRADE_MODAL = 'see_upgrade_modal';
const EVENT_START_TRIAL = 'start_trial';
const EVENT_UPGRADE = 'upgrade';
const EVENT_CANCEL_SUBSCRIPTION = 'cancel_subscription';
const EVENT_AD_BLOCKER_DETECTED = 'ad_blocker_detected';
const EVENT_BRAVE_BROWSER_DETECTED = 'brave_browser_detected';
/**
 * Event tracker
 */
function visitApp({ loggedIn }) {
    try {
        gtag('event', EVENT_VISIT_APP, {
            event_label: loggedIn ? 'logged_in' : 'not_logged_in',
        });
    }
    catch (e) { }
}
function signUp({ method }) {
    try {
        gtag('event', EVENT_SIGNUP, {
            event_label: method,
        });
    }
    catch (e) { }
}
function seeUpgradeModal() {
    try {
        gtag('event', EVENT_SEE_UPGRADE_MODAL);
    }
    catch (e) { }
}
function startTrial() {
    try {
        gtag('event', EVENT_START_TRIAL);
    }
    catch (e) { }
}
function upgrade({ planType }) {
    try {
        gtag('event', EVENT_UPGRADE, {
            event_label: planType,
        });
    }
    catch (e) { }
}
function cancelSubscription() {
    try {
        gtag('event', EVENT_CANCEL_SUBSCRIPTION);
    }
    catch (e) { }
}
function adBlockerDetected() {
    try {
        gtag('event', EVENT_AD_BLOCKER_DETECTED);
    }
    catch (e) { }
}
function braveBrowserDetected() {
    try {
        gtag('event', EVENT_BRAVE_BROWSER_DETECTED);
    }
    catch (e) { }
}
// function incognitoDetected() {
//   try {
//     gtag('event', EVENT_INCOGNITO_DETECTED);
//   } catch (e) {}
// }
/**
 * Exports
 */
const EventTracker = {
    visitApp,
    signUp,
    seeUpgradeModal,
    startTrial,
    upgrade,
    cancelSubscription,
    adBlockerDetected,
    braveBrowserDetected,
    // incognitoDetected,
};
export default EventTracker;
